<div class="grid-row tabs dashboard-tabs mt-3 mb-4">
	<div></div>
	<!-- REFRESH BUTTON -->
	<eif-custom-button
		[text]="'button.refresh' | translate"
		[preIcon]="'fa-solid fa-sync-alt'"
		(action)="refreshAllData()">
	</eif-custom-button>
</div>

<!-- CURRENCIES -->
<div class="grid-row mt-4">
	@if (orderedCurrencies.length > 1) {
		<ul class="currency-wrap mt-0 mb-4">
			@for (orderedCurrency of orderedCurrencies; track orderedCurrency.Currency; let i = $index) {
				<li>
					<eif-custom-button
						[text]="orderedCurrency.Currency"
						[variant]="orderedCurrency.Selected ? 'standard' : 'outlined'"
						[color]="orderedCurrency.Selected ? 'primary' : 'neutral'"
						(action)="clickedCurrency(orderedCurrency.Currency)">
					</eif-custom-button>
				</li>
			}
		</ul>
	}

	<div class="dashboard-cards-wrap">
		<eif-dashboard-card
			value="{{ contractsAvailableAmount | currencyLocale: selectedCurrency }}"
			subValue="{{ contractsAvailableAmountRatio | numberLocale: '1.2-2' }}%"
			description="{{ 'dashboard-buyer.contractsAvailableAmount' | translate }}"
			[icon]="'fa-regular fa-chart-pie-alt'"
			[loading]="loadingContractsAvailableAmount"
			[color]="'1'" />
		<eif-dashboard-card
			value="{{ contractedAmount | currencyLocale: selectedCurrency }}"
			description="{{ 'dashboard-buyer.contractedAmount' | translate }}"
			[icon]="'fa-solid fa-chart-pie-alt'"
			[loading]="loadingContractedAmount"
			[color]="'2'" />
		<eif-dashboard-card
			value="{{ currentFundingRequestsAmount | currencyLocale: selectedCurrency }}"
			description="{{ 'dashboard-buyer.currentFundingRequestsAmount' | translate }}"
			[icon]="'fa-regular fa-hand-holding-dollar'"
			[loading]="loadingCurrentFundingRequestsAmount"
			[color]="'3'" />
		<eif-dashboard-card
			value="{{ notPaidDocuments | currencyLocale: selectedCurrency }}"
			description="{{ 'dashboard-buyer.notPaidDocuments' | translate }}"
			[icon]="'fa-light fa-file-invoice'"
			[loading]="loadingNotPaidDocuments"
			[color]="'4'" />
		<eif-dashboard-card
			value="{{ loggedUser?.Companies.length }}"
			description="{{ 'dashboard-buyer.companies' | translate }}"
			[icon]="'fa-regular fa-building'"
			[color]="'5'" />
		<eif-dashboard-card
			value="{{ suppliersActiveConnections }}"
			description="{{ 'dashboard-buyer.suppliersActiveConnections' | translate }}"
			[icon]="'fa-regular fa-chart-network'"
			[loading]="loadingSuppliersActiveConnections"
			[color]="'8'" />
		<eif-dashboard-card
			value="{{ confirmingPendingApprovalDocumentsAmount }}"
			description="{{ 'dashboard-buyer.confirmingPendingApprovalDocumentsAmount' | translate }}"
			[icon]="'fa-regular fa-hourglass-clock'"
			[loading]="loadingConfirmingPendingApprovalDocumentsAmount"
			[color]="'7'"
			[hasAction]="true"
			(action)="navigateToFilesIntegration(FileStatus.PendingBuyerApproval)" />
	</div>
</div>

<!-- Charts area -->
<div class="dashboard-chart-wrapper mt-4">
	<div class="is-label">
		{{ 'dashboard-supplier.documentForecast' | translate }}
	</div>
	<div
		id="chart-1"
		class="dashboard-chart">
		<ngx-charts-bar-vertical-stacked
			[scheme]="documentForecastChart.ColorScheme"
			[results]="documentForecastChart.Results"
			[xAxis]="documentForecastChart.ShowXAxis"
			[yAxis]="documentForecastChart.ShowYAxis"
			[showXAxisLabel]="documentForecastChart.ShowXAxisLabel"
			[xAxisLabel]="documentForecastChart.XAxisLabel"
			[yAxisLabel]="documentForecastChart.YAxisLabel"
			[showYAxisLabel]="documentForecastChart.ShowYAxisLabel"
			[legend]="documentForecastChart.ShowLegend"
			[legendTitle]="documentForecastChart.LegendTitle"
			[noBarWhenZero]="true">
			<ng-template
				#tooltipTemplate
				let-model="model">
				<!-- fields are series/name/value -->
				<div class="tt">
					<div>{{ model.series }} &#8226; {{ model.name }}</div>
					{{ model.value | currencyLocale: selectedCurrency }}
				</div>
			</ng-template>
		</ngx-charts-bar-vertical-stacked>
	</div>
</div>
